module.exports = __webpack_public_path__ + "img/web7.9969f082.svg";